import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from '@buoyhealth/common.buoy-button';
import Card from './Card';
import { Paragraph } from 'src/interviews/components/Layout/Embedded';
import type { ReactNode, ReactElement } from 'react';

function RelatedCard(props: {
  ctaText: string;
  description: ReactNode;
  onCtaClick: () => void;
  href: string;
  impressionRef: React.RefObject<any>;
  key: string;
  subtitle: string;
  subtitleIcon?: ReactElement;
  title: string;
  containerClassName?: string;
}) {
  const {
    ctaText = 'Read article',
    description,
    onCtaClick,
    href,
    impressionRef,
    subtitle,
    subtitleIcon,
    title,
    containerClassName = 'bp-max-w-[300px]',
  } = props;

  return (
    <Card
      cta={
        <Link className="bp-mt-auto bp-flex bp-w-full bp-items-center bp-justify-between bp-rounded-3xl bp-bg-indigo-50 bp-px-3 bp-py-2 !bp-no-underline">
          <Paragraph className="!bp-text-primary-50 !bp-text-sm">{ctaText}</Paragraph>
          <ArrowForwardIcon className="bp-h-4 bp-w-4" />
        </Link>
      }
      description={description}
      onClick={onCtaClick}
      href={href}
      innerRef={impressionRef}
      subtitle={
        <div className="bp-flex bp-items-center">
          {subtitleIcon && <span className="bp-pr-1">{subtitleIcon}</span>}
          <Paragraph className="!bp-text-xs">{subtitle}</Paragraph>
        </div>
      }
      title={title}
      containerClassName={containerClassName}
    />
  );
}

export default RelatedCard;
